import React from 'react';
import { Toaster } from 'react-hot-toast';
import { useTheme } from '@mui/material/styles';

export const ToastContainer: React.FC = () => {
  const theme = useTheme();

  return (
    <Toaster
      position="top-right"
      containerStyle={{
        top: 13,
        right: 13,
      }}
      toastOptions={{
        style: {
          background: theme.palette.background.paper,
          color: theme.palette.text.primary,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: '8px',
          padding: '12px 16px',
          fontSize: '14px',
        },
        success: {
          iconTheme: {
            primary: theme.palette.primary.main,
            secondary: theme.palette.background.paper,
          },
          style: {
            background: theme.palette.background.paper,
            color: theme.palette.text.primary,
            borderLeft: `4px solid ${theme.palette.primary.main}`,
          },
        },
        error: {
          iconTheme: {
            primary: theme.palette.secondary.main,
            secondary: theme.palette.background.paper,
          },
          style: {
            background: theme.palette.background.paper,
            color: theme.palette.text.primary,
            borderLeft: `4px solid ${theme.palette.secondary.main}`,
          },
        },
        loading: {
          iconTheme: {
            primary: theme.palette.primary.main,
            secondary: theme.palette.background.paper,
          },
          style: {
            background: theme.palette.background.paper,
            color: theme.palette.text.primary,
          },
        },
      }}
    />
  );
};

